import { CommonModule } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	NgModule,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

import { QuotaTypeEnum } from '@reach/interfaces/quotas/quota-type.enum';

import { QuotaApiService } from '~app-client/api/services';
import { QuotaService } from '~app-client/core/services';
import { ReachModalsService } from '~app-client/modals/services';
import { Implicit } from '~app-client/modals/types';

@Component({
	standalone: false,

	selector: 'chat-ai-exceeded',
	templateUrl: './chat-ai-exceeded.component.html',
	styleUrls: ['./chat-ai-exceeded.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'error-modals' } }],
})
export class ChatAiExceededComponent implements AfterViewInit {
	@ViewChild('tpl')
	private tpl: TemplateRef<Implicit<void>>;

	private readonly quotaService = inject(QuotaService);

	private readonly $quota = toSignal(this.quotaService.quotas$);

	public readonly $quotaNodes = computed(() => {
		const quota = this.$quota();
		if (!quota) {
			return null;
		}
		const { total, used } = quota[QuotaTypeEnum.MONTHLY_CHAT_KNOWLEDGE_MESSAGES];
		return { total, used };
	});

	constructor(
		private readonly quotaApi: QuotaApiService,
		private readonly modalsService: ReachModalsService,
		private readonly router: Router
	) {}

	async ngAfterViewInit(): Promise<void> {
		this.modalsService.openModal(this.tpl, null, {
			closeOnOutsideClick: false,
		});

		await this.quotaService.load(true);
	}

	public async confirm(): Promise<void> {
		await this.router.navigate(['/', 'home', 'profile', 'usage'], {
			queryParams: { usagePanel: 'chat_ai_words' },
			queryParamsHandling: 'merge',
		});
		this.cancel();
	}

	public cancel(): void {
		this.modalsService.closeModal();
	}
}

@NgModule({
	declarations: [ChatAiExceededComponent],
	imports: [CommonModule, TranslocoModule],
	exports: [ChatAiExceededComponent],
})
export class ChatAiExceededModule {}
